import { render, staticRenderFns } from "./DataAnalysisResult.vue?vue&type=template&id=a2dd98ba&scoped=true&"
import script from "./DataAnalysisResult.vue?vue&type=script&lang=js&"
export * from "./DataAnalysisResult.vue?vue&type=script&lang=js&"
import style0 from "./DataAnalysisResult.vue?vue&type=style&index=0&id=a2dd98ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dd98ba",
  null
  
)

export default component.exports